<div id="main_theme_id_class" style="display: inline" [class]="appService.theme">
  @if (loader.isLoading | async) {
    <mat-progress-bar style="z-index: 999999; position:absolute;" mode="indeterminate">
    </mat-progress-bar>
  }

  <!-- <div class="debug">
  <button (click)="debug()">Log tokens</button>
  <button (click)="trace()">Trace primary</button>
</div> -->

<router-outlet></router-outlet>
</div>